module.exports = __webpack_public_path__ + "static/img/honor3.34f84a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor3.png
// module id = OrJy
// module chunks = 0